import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setNewPasswordService } from "./set-new-password.service";

interface ApiResponse {
    statusCode: number;
    message: string;
    response?: any;
}

const initialState = {
    message: "",
    isError: false,
    isSuccess: false,
    loading: false,
    error: null as string | null,
};

export const setNewPassword = createAsyncThunk(
    "setNewPassword/setNewPassword",
    async ({ token, password }: { token: string; password: string }, thunkAPI) => {
        try {
            const response = await setNewPasswordService(token, password) as ApiResponse;

            if (!(response.statusCode === 200 || response.statusCode === 201)) {
                return thunkAPI.rejectWithValue(response.message);
            }

            return response.response;
        } catch (error: any) {
            const message =
                (error?.response &&
                    error?.response?.data &&
                    error?.response?.data?.message) ||
                error?.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const setNewPasswordSlice = createSlice({
    name: "setNewPassword",
    initialState,
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = "";
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setNewPassword.pending, (state) => {
                state.loading = true;
                state.isSuccess = false;
                state.isError = false;
                state.message = "";
                state.error = null;
            })
            .addCase(setNewPassword.fulfilled, (state, action) => {
                state.loading = false;
                state.isSuccess = true;
                state.isError = false;
                state.message = "";
                state.error = null;
            })
            .addCase(setNewPassword.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.payload as string;
                state.error = action.payload as string;
            });
    },
});

export const { reset } = setNewPasswordSlice.actions;
export default setNewPasswordSlice.reducer;
